import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  state: {
    rootState1: 'rootState1',
    rootState2: 'rootState2',
  },
  mutations: {},
  actions: {},
  getters,
  namespaced: true,
});
